import { AvField, AvForm } from 'availity-reactstrap-validation';
import React from 'react';
import { Button, Card, CardBody, FormGroup, Label } from 'reactstrap';

export const AddDistrict = (props) => {
  return (
    <>
      <Card>
        <CardBody>
          <AvForm className='needs-validation' onSubmit={props.onAdd}>
            <FormGroup>
              <Label htmlFor='name'>Name</Label>
              <AvField
                name='name'
                placeholder='Name'
                type='text'
                errorMessage='Enter Name'
                className='form-control'
                validate={{ required: { value: true } }}
                id='name'
              />
            </FormGroup>
            <div className='text-right'>
              <Button disabled={props.disabled}>Submit</Button>
            </div>
          </AvForm>
        </CardBody>
      </Card>
    </>
  );
};
